<template>
  <ul class="nav__links">
    <li v-for="link in safeLinks" class="nav__link">
      <nuxt-link
        v-if="link?.href || link?.slug?.current"
        :to="localePath(`${link.href != null ? link.href : '/' + link.slug.current}`)"
        @click="$toggleNav"
      >{{ locale === 'en' ? link?.text?.en : link?.text?.jp }}</nuxt-link>
    </li>
  </ul>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from 'vue'
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
  content: Object
})
const safeLinks = computed(() => Array.isArray(props.content) ? props.content : [])
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.nav__links {
  list-style: none;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
  .nav__link {
    a {
      color: v.$white;
      display: block;
			font-family: var(--font);
      font-size: v.$font-size-med;
			font-weight: 400;
      text-decoration: none;
      transition: 0.3s;
    }
  }
}
.nav--active {
  .nav__links {
    top: 0;
    .nav__link {
      opacity: 1;
      transform: translateY(0);
      transition: 0.5s;
      a {
        margin: 0;
        opacity: 1;
        padding: 0.5rem 0.5rem 0.5rem 0;
        transition: 0.3s;
        visibility: visible;
				@include v.respond-to('medium') {
					padding: 0.5rem;
				}
      }
    }
  }
}
</style>
